import React, { useState, useEffect } from "react";
import Autocomplete from "../../Autocomplete/Autocomplete";
import "./AutoCompletListBox.css";
import "../Styles/SvgCommand.css";
import useSize from "../../../Hooks/useSize.js";
import useBuildStyle from "../../../Hooks/useBuildStyle";
import useSetRowData from "../../../Hooks/useSetRowData.js";

export default function AutoCompletListBox(props) {
  const [isDragOver, setDragover] = useState(false);
  const [actualWidth, actualHeight] = useSize(props.style.width.value, props.style.height.value, props.data.id);
  const buildStyle = useBuildStyle();
  const setRowData = useSetRowData();
  const [data, setData] = useState({actualize:props.data.properties.actualize.value});

  /*const onDropDownItemClick = (itemSelected) => {};
  const shiftPosition = 1;*/
  useEffect(() => {
     props.updateSize(props.data.id, actualWidth, actualHeight);
  }, [actualWidth,actualHeight]);

  useEffect(() => {
    setData({...data, actualize:props.data.properties.actualize.value})
  }, [props.data.properties.actualize.value]);

  const getContainerStyle = () => {
    var newStyle = buildStyle(props.style);
    //newStyle["position"] = "absolute";
   
    newStyle["border"] = isDragOver ? "1px dashed #1f79e1" : 
    props.errors ? props.errors.border : props.style.border.value;
    return newStyle;
  };
  const onDropColumn = (e) => {
    e.stopPropagation();
    props.onDropColumn(e, props.data);
    setDragover(false);
  };
  const onDrag = (e, dragOver) => {
    if (dragOver !== isDragOver)
      setDragover(dragOver);
   
  };

  const getStyle = () => {
    var newStyle = {};
    
    newStyle["width"] = parseInt(props.style.width.value.slice(0,-2)) - 15 + "px" ;
    newStyle["height"] = parseInt(props.style.height.value.slice(0,-2)) - 10 + "px" ;
    newStyle["top"] = props.style.top && props.style.top.value;
    newStyle["left"] = props.style.left && props.style.left.value;
    newStyle["position"] = "absolute";
    
    return newStyle;
  };

  const getCurrentData = () => {

    let option = props.data.properties.data.option && props.data.properties.data.option.toLowerCase() //props.data.option && props.data.option.filter(item => item.type == "properties" && item.menu == "data")[0]
    
    let current = props.data.properties.data.value
   
    if (option == "mapping")
      return setRowData(JSON.parse(JSON.stringify(props.data)))
      //return option && (current[option].data ? current[option].data : [])
    else
      return option && current[option].values ? 
        current[option].values.filter(item => item.id == current[option].id)[0].details.map(detail => {return {id:detail.key.value, item:detail.value.value}})
          : []
    /*
    let current = props.data.properties.data.value
    return current.option && current[current.option.toLowerCase()].values ? 
    current[current.option.toLowerCase()].values.filter(item => item.id == current[current.option.toLowerCase()].id)[0]
      .details.map(detail => {return {id:detail.key.value, item:detail.value.value}})
    : []*/
    
  
  };

  const getInitialValue = () => {
    
    if (props.onlyLabel)
      return typeof props.data.properties.text.value === 'object' ? "AutoCompleteListBox" : props.data.properties.text.value
    else
      return props.data.properties.text.value.item
  };

  const isAddInGrid  = () => {
    return props.style.position.value == "relative"
  };
  
  const getAutoCompleteListBox  = () => {
    return (
      
  <React.Fragment >
      <div 
        onClick={props.onClick} 
        style={getContainerStyle()}
        id={props.data.id}>
      </div>
      <div 
        draggable={props.draggable}
        onDragStart={(e) => props.onDragStart(e)}
        onDrop={(e) => props.onlyLabel && onDropColumn(e)}
        onDragOver={(e) => props.onlyLabel && onDrag(e, true)}
        onDragLeave={(e) => props.onlyLabel && onDrag(e, false)}
        onClick={(e) => props.onClick(e)}
        onMouseLeave={(e) => props.onMouseLeave(e)}
        //onMouseOver={(e) => props.onMouseOver(e)}
        onMouseEnter={(e) => props.onMouseEnter(e)}
        onMouseDown={(e) => props.onMouseDown(e)}
        style={getStyle()}>
        <Autocomplete 
          placeholder={props.data.properties.placeholder.value }
          id={"Autocomplete" + props.data.id}
          isWrapped= {true} 
          style={getStyle() }  
          value = {getInitialValue() } 
          containerStyle={buildStyle(props.style) }
          onlyLabel={props.onlyLabel}
          emphasised= {true}
          onChange={(e, value) => props.onChange(e, {item:value}) }
          onSelectedItem={(e, itemSelected) => props.onChange(e, itemSelected)}
          data = {getCurrentData()}/>
      </div>
     </React.Fragment>
     //</div>
    );

  };

  return ( isAddInGrid() ? 
  //<div style={{position:props.style.position.value, width:props.style.width.value, height:props.style.height.value} }>
    getAutoCompleteListBox()
  //</div>
  :  <React.Fragment>
      {getAutoCompleteListBox()}
      {props.errors && !props.errors.isColumn && <input readOnly style={props.errors.styles} value={props.errors.value} />}
    </React.Fragment>
    )
/*
    //<div style={{position:props.style.position, width:props.style.width, height:props.style.height} } >
      <React.Fragment >
      <div
        onClick={props.onClick} 
        style={getContainerStyle()}
        id={props.data.id}/>
    
      <div 
        draggable={props.draggable}
        onDragStart={(e) => props.onDragStart(e)}
        onDrop={(e) => props.onlyLabel && onDropColumn(e)}
        onDragOver={(e) => props.onlyLabel && onDrag(e, true)}
        onDragLeave={(e) => props.onlyLabel && onDrag(e, false)}
        onClick={props.onClick} 
        style={getStyle()}>
        <Autocomplete 
          placeholder={props.data.properties.placeholder.value }
          isWrapped= {true} 
          style={getStyle() }  
          containerStyle={props.style }
          onlyLabel={props.onlyLabel}
          emphasised= {true}
          onChange={(e, value) => props.onChange(e, {item:value}) }
          onSelectedItem={(e, itemSelected) => props.onChange(e, itemSelected)}
          data = {getCurrentData()}/>
      </div>
      </React.Fragment>
   //</div>
  );*/
}
